import { useEffect, useRef, useState } from 'react';
import { FormFeedback, FormGroup, Input } from 'reactstrap';

const normalizeValue = (nextValue) =>
  nextValue === null || nextValue === undefined ? '' : String(nextValue);

const FormularioGlobalBufferedInput = ({
  className,
  commitOnChange = false,
  disabled,
  inputClassName,
  invalid,
  label,
  max,
  maxLength,
  min,
  onCommit,
  placeholder,
  rows,
  type = 'text',
  value,
  validationMessage,
}) => {
  const [localValue, setLocalValue] = useState(normalizeValue(value));
  const localValueRef = useRef(localValue);
  const lastCommittedRef = useRef(normalizeValue(value));
  const isFocusedRef = useRef(false);

  const commit = (nextValue = localValueRef.current) => {
    if (nextValue === lastCommittedRef.current) return;

    lastCommittedRef.current = nextValue;
    onCommit && onCommit(nextValue);
  };

  useEffect(() => {
    const nextValue = normalizeValue(value);
    const semEdicaoLocal = localValueRef.current === lastCommittedRef.current;
    lastCommittedRef.current = nextValue;

    if (
      (!isFocusedRef.current || semEdicaoLocal) &&
      nextValue !== localValueRef.current
    ) {
      localValueRef.current = nextValue;
      setLocalValue(nextValue);
    }
  }, [value]);

  const handleChange = (event) => {
    const nextValue = event.target.value;

    localValueRef.current = nextValue;
    setLocalValue(nextValue);

    if (commitOnChange) {
      commit(nextValue);
    }
  };

  return (
    <FormGroup className={className}>
      {label && <label>{label}</label>}
      <Input
        className={inputClassName}
        disabled={disabled}
        invalid={invalid || !!validationMessage}
        max={max}
        maxLength={maxLength}
        min={min}
        onBlur={() => {
          isFocusedRef.current = false;
          commit();
        }}
        onChange={handleChange}
        onFocus={() => {
          isFocusedRef.current = true;
        }}
        placeholder={placeholder}
        rows={rows}
        type={type}
        value={localValue}
      />
      {validationMessage && <FormFeedback>{validationMessage}</FormFeedback>}
    </FormGroup>
  );
};

export default FormularioGlobalBufferedInput;
